import { NgModule } from '@angular/core';

import { provideFormlyConfig } from '@ngx-formly/core';

import { AddressUiFieldComponent } from './address-ui/address-ui.field.component';
import { AddressFieldComponent } from './address/address.field.component';

@NgModule({
  imports: [AddressFieldComponent, AddressUiFieldComponent],
  declarations: [],
  exports: [AddressFieldComponent],
  providers: [
    provideFormlyConfig({
      types: [
        {
          name: 'address',
          component: AddressFieldComponent,
          wrappers: ['form-field-labeled'],
        },
      ],
    }),
  ],
})
export class SharedFormUiGoogleMapsModule {}
